import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { VolunteerSection } from "@/components/sections/VolunteerSection";
import { FAQSection } from "@/components/sections/FAQSection";

export default function VolunteerPage() {
  return (
    <main>
      <PageHeader eyebrow="Volunteer" title="Be part of a nationwide movement." lead="CAF volunteers work with real teams on real programs — with training, mentorship and recognition." />
      <VolunteerSection />
      <FAQSection />
    </main>
  );
}
